<div class="logo">
    <img src="./LavaLamp.png" width="103" alt="Lava Lamp Logo">
</div>
<style lang="scss">
  @use "../theme/_smui-theme.scss";

  .logo {
    display: grid;
    grid-column: col-start / span 2;
  }

</style>